import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

/**
 * Global capture of Chromium's `beforeinstallprompt` event.
 *
 * We prevent the browser from surfacing its own install banner globally on
 * public pages and stash the event so only the eligible in-product surface
 * (Pro Carer Hub → Shift Kit section) can call `.prompt()` on it.
 */
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.__jccDeferredInstallPrompt = e;
    window.dispatchEvent(new CustomEvent("jcc:beforeinstallprompt"));
  });
  window.addEventListener("appinstalled", () => {
    window.__jccDeferredInstallPrompt = null;
    window.dispatchEvent(new CustomEvent("jcc:appinstalled"));
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
